import type { Case } from "./useRealtimeCases";
import { formatParisDate, formatParisTime } from "./parisDateTime";

export function caseDrawerTitle(c: Case) {
  const dateKnown = !!c.event_date && Number.isFinite(Date.parse(c.event_date));
  const pax = c.participants ?? c.pax;
  return [
    dateKnown ? formatParisDate(c.event_date!, { day: "2-digit", month: "2-digit", year: "numeric" }) : "Date à préciser",
    dateKnown && c.event_time_provided !== false ? formatParisTime(c.event_date!) : "Heure à préciser",
    pax != null ? `${pax} pax` : "Pax à préciser",
    c.company_name?.trim() || "Entreprise à préciser",
    c.client_first_name?.trim() || "Prénom à préciser",
    c.center?.trim() || "Centre à préciser",
  ].join(" – ");
}

/** Lecture des anciens récapitulatifs de formulaire, uniquement pour les champs absents. */
export function requestDetailsFromMessages(messages: { content: string | null }[]) {
  let payment: string | null = null;
  let discovery: string | null = null;
  for (const message of messages) {
    for (const line of (message.content || "").split("\n")) {
      const match = line.match(/^\s*(?:-\s*)?(Paiement|Moyens? de paiement|Modes? de paiement|Provenance déclarée|Comment (?:nous avez-vous|vous nous avez) connus\s*\??)\s*:\s*(.+)$/i);
      if (!match || /^(non précisé[es]*|non renseigné[es]*|aucun)$/i.test(match[2].trim())) continue;
      if (/paiement/i.test(match[1])) payment ??= match[2].trim();
      else discovery ??= match[2].trim();
    }
  }
  return { payment, discovery };
}
